import Location from './Vector (10).png';
import Web from './Vector (4).png';
import Calender from './Vector (5).png';
import Location2 from './Vector (8).png';
import Calender2 from './Vector (9).png';
import UserImage from './user.png';
import Envelope from './Envelope.png';
import Phone from './PhoneCall.png';
import Map from './MapPinLine.png';

const assets = {
  location: Location,
  web: Web,
  calender: Calender,
  calender2: Calender2,
  location2: Location2,
  userImage: UserImage,
  envelope: Envelope,
  phone: Phone,
  map: Map,
};

const getImage = key => {
  if (!assets[key]) {
    console.warn(`Image with key "${key}" not found.`);
    return null;
  }
  return assets[key];
};

export default getImage;
